/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
Object.defineProperty(exports, "positionsMap", {
  enumerable: true,
  get: function get() {
    return _positionsMap.default;
  }
});
var _positionsMap = _interopRequireDefault(require("./positionsMap"));
var _getPosition = _interopRequireDefault(require("./getPosition"));
var _default = _getPosition.default;
exports.default = _default;